/** FAQ accordion — one open item per list */
(function () {
  function setOpen(item, open) {
    const q = item.querySelector('.zm-faq-q');
    const a = item.querySelector('.zm-faq-a');
    item.classList.toggle('is-open', open);
    if (q) q.setAttribute('aria-expanded', open ? 'true' : 'false');
    // Keep maxHeight fallback for older browsers; CSS grid rows handle modern
    if (a && !CSS.supports?.('grid-template-rows', '0fr')) {
      a.style.maxHeight = open ? `${a.scrollHeight}px` : null;
    }
  }

  document.querySelectorAll('[data-zm-faq-list]').forEach((list) => {
    list.querySelectorAll('.zm-faq-item').forEach((item) => {
      const q = item.querySelector('.zm-faq-q');
      if (!q) return;

      if (item.classList.contains('is-open')) setOpen(item, true);

      q.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        list.querySelectorAll('.zm-faq-item').forEach((other) => setOpen(other, false));
        if (!isOpen) setOpen(item, true);
      });
    });
  });
})();
